exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mdl-select ::ng-deep .mdl-popover {\n  padding: 5px;\n  margin: 2px 0 0 -6px;\n}\n\nmdl-select ::ng-deep .mdl-textfield {\n  width: 90%;\n  margin-left: 4px;\n  padding: 20px 10px;\n}\n\n", ""]);

// exports
